import React from "react";
import {Col, Row} from "react-bootstrap";


import "./index.scss";


type UserDashboardPageContentProps = {
    headingText?: string;
    descriptionText?: string;
    children?: React.ReactNode | React.ReactNode[];
}


export const UserDashboardPageContent:React.FC<UserDashboardPageContentProps> = ({
    headingText, descriptionText, children
}) => {

    return (
        <Col xs={12} lg={9} className={'user-dashboard-page__page-content'}>
            <Row className={'user-dashboard-page__page-content__content'}>

                <Col xs={12} className={'user-dashboard-page__page-content__content-wrapper'}>
                    <Row className={'user-dashboard-page__page-content__content-wrapper__content'}>

                        {(headingText || descriptionText) &&
                        <Col xs={12} className={'user-dashboard-page__page-content__content-header'}>
                            <Row className={'user-dashboard-page__page-content__content-header__content'}>
                                {headingText &&
                                <Col xs={12} className={'user-dashboard-page__page-content__content-header__heading-text'}>
                                    <span>{headingText}</span>
                                </Col>
                                }
                                {descriptionText &&
                                <Col xs={12} className={'user-dashboard-page__page-content__content-header__description-text'}>
                                    <span>{descriptionText}</span>
                                </Col>
                                }
                            </Row>
                        </Col>
                        }

                        {children}

                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardPageContent;
